const testId = (id: string | null, renderOnServer: boolean = false): string | null => {
    if (typeof window !== 'undefined' && renderOnServer === false) {
        return window['environment']['name'] === 'local' || 'development' || 'staging' ? id : null;
    } else if (typeof window === 'undefined' && renderOnServer === true) {
        return id;
    }
    return null;
};

export default testId;
